
import { numProps, strProps } from "@/Common/Table/column";
import { ColumnType } from "@/Common/Table/type";
import { ViewCheckInventory } from "@/Models/Views/ViewInventory";
import { Form, Modal, Space, Table, message } from "antd";
import { useCallback, useEffect, useMemo, useState } from "react";
import { updCheckInventory } from "@/Api/StockSlotController";
function getColumns(): ColumnType<ViewCheckInventory>[] {
    return [

        numProps("index", "序号", 50, true),
        numProps("id", "表格序号", 50, true),
        strProps("goodName", "物品名称", 120, true, true),
        strProps("standard", "物品规格", 200, true, true),
        numProps("quantity", "数量", 100, true),
        numProps("profitLossQuantity", "增减数量", 100, true),
        strProps("stockCode", "托盘条码", 100, true, true)
    ];
}



export function CheckInventory({ record, onCancel }: {
    record: ViewCheckInventory[];
    onCancel: () => void;
}) {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const columns = useMemo(getColumns, []);
    const [data, setData] = useState<ViewCheckInventory[]>([]);

    useEffect(() => {
        (async () => {
            setData(record);
            setLoading(true);
            try {

            } catch (error) {
                console.error(error);
            }
            finally {
                setLoading(false);
            }
        })();
    }, [record]);
    const onOk = useCallback(async () => {

        setLoading(true);
        updCheckInventory(record).then(s => {
            if (s > 0) {

                message.success('操作成功！'); onCancel();
            } else {

                message.success('操作失败！');
            }

        }).catch(e => console.error(e))
            .finally(() => setLoading(false));
    }, [onCancel, record]);

    return <Modal open confirmLoading={loading} onCancel={onCancel} width={1600} onOk={onOk} title={<Space>

    </Space>} >
        <Form form={form} component={false}>
            <Table
                loading={loading}
                bordered
                rowKey={s => s.index}
                size="small"
                scroll={{ y: 240 }}
                dataSource={data}
                columns={columns}
            />
        </Form>
    </Modal>;
}


